'use strict';

angular.module('user')
    .component('userProfilePasswordForm', {
        templateUrl: 'js/modules/user/components/profile-password-form/template.html',
        controller: 'UserProfilePasswordFormController',
    });
